// Read only owned, persisted results; the legacy ActionCable path is unchanged.
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
export async function requestSuggestions(chatId, messageId, csrf, { fetcher = fetch, sleep = ms => new Promise(resolve => setTimeout(resolve, ms)), signal } = {}) {
  if (![chatId, messageId].every(value => UUID.test(value))) throw new Error('Select a completed tutor message.');
  const url = `/langua/cartus_chats/${chatId}/messages/${messageId}/suggestions`;
  const headers = { 'Content-Type': 'application/json', 'X-CSRF-Token': csrf };
  for (let attempt = 0; attempt < 45; attempt++) {
    const response = await fetcher(attempt === 0 ? '/langua/suggestions' : url, { method: attempt === 0 ? 'POST' : 'GET', headers, credentials: 'same-origin', signal,
      ...(attempt === 0 ? { body: JSON.stringify({chat_id: chatId, chat_message_id: messageId}) } : {}) });
    if (!response.ok) throw new Error('Reply suggestions are unavailable for this message.');
    const result = await response.json();
    if (result.status === 'completed') {
      if (!Array.isArray(result.suggestions) || result.suggestions.length !== 2 || !result.suggestions.every(s => typeof s === 'string' && s.trim() && s.length <= 2000)) throw new Error('Invalid reply suggestions.');
      return result.suggestions;
    }
    if (!['queued', 'running'].includes(result.status)) throw new Error('Reply suggestions are unavailable for this message.');
    await sleep(1500);
  }
  throw new Error('Suggestions are taking longer than expected. Try opening them again shortly.');
}

// Transport only: presentation stays in the consumer SuggestedReplyService.
export async function showTenantSuggestions(chat, { page = document, fetcher = fetch } = {}) {
  const button = chat.suggestionBtn;
  if (!button || button.disabled) return;
  chat.chatElement.querySelectorAll?.('.js-cartus-suggestion-error').forEach(error => error.remove());
  const messages = page.querySelectorAll('.chat-content .chat-message:not(.self):not(.loading)[data-chat-message-id]');
  const message = messages[messages.length - 1];
  button.disabled = true; button.classList.add('pulse');
  chat.tenantSuggestionAbort?.abort();
  const abort = new AbortController(); chat.tenantSuggestionAbort = abort;
  let timedOut = false;
  const timeout = setTimeout(() => { timedOut = true; abort.abort(); }, 75000);
  try {
    const suggestions = await requestSuggestions(chat.chatId, message?.dataset.chatMessageId, page.querySelector('meta[name="csrf-token"]')?.content, { fetcher, signal: abort.signal });
    const current = page.querySelectorAll('.chat-content .chat-message:not(.self):not(.loading)[data-chat-message-id]');
    if (abort.signal.aborted || !message?.isConnected || current[current.length - 1] !== message) return;
    const data = { suggestions };
    chat.suggestions[message.dataset.chatMessageId] = data;
    await chat.handleSuggestedReply(data, message.dataset.chatMessageId, () => !abort.signal.aborted && message.isConnected);
  } catch (_) {
    if (abort.signal.aborted && !timedOut) return;
    const error = page.createElement('div');
    error.className = 'alert alert-danger js-error-message js-cartus-suggestion-error font-weight-bold'; error.setAttribute('role', 'alert');
    error.textContent = I18n.t('javascript.chat.errors_persist_contact'); chat.chatElement.appendChild(error);
  } finally { clearTimeout(timeout); if (chat.tenantSuggestionAbort === abort) delete chat.tenantSuggestionAbort; button.disabled = false; button.classList.remove('pulse'); }
}
